import { render, staticRenderFns } from "./Verdicts.vue?vue&type=template&id=0e5216f4&scoped=true"
import script from "./Verdicts.vue?vue&type=script&lang=js"
export * from "./Verdicts.vue?vue&type=script&lang=js"
import style0 from "./Verdicts.vue?vue&type=style&index=0&id=0e5216f4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5216f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e5216f4')) {
      api.createRecord('0e5216f4', component.options)
    } else {
      api.reload('0e5216f4', component.options)
    }
    module.hot.accept("./Verdicts.vue?vue&type=template&id=0e5216f4&scoped=true", function () {
      api.rerender('0e5216f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Verdicts.vue"
export default component.exports